import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  CircularProgress,
  DialogTitle,
  Button,
} from "@mui/material";
// import Button from "../Button/Button";
import { boolean } from "yup";

interface ModalProps {
  modalOpen: boolean;
  closeModal: () => void;
  heading: string;
  subheading?: string;
  children: React.ReactNode;
  width?: string;
  saveButtonText?: string | boolean;
  onSave?: () => void;
  errorMessage?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
  isSubmitting?: boolean;
  hideaddbutton?: boolean;
}

function Modal({
  modalOpen,
  closeModal,
  heading,
  subheading,
  children,
  width,
  saveButtonText = "Save",
  onSave,
  errorMessage,
  hideHeader = false,
  hideFooter = false,
  isSubmitting = false,
  hideaddbutton
}: ModalProps) {
  return (
    <Dialog
      open={modalOpen}
      onClose={isSubmitting ? undefined : closeModal}
      fullWidth
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            width: width || "500px",
            borderRadius: "12px",
            // padding: "32px 24px",
            gap: "16px",
          },
        },
      }}
    >
      <DialogTitle sx={{
        paddingBottom: "0.4rem",
        paddingTop : "2rem",
      }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {heading}
          </Typography>

          <Typography
            sx={{
              fontSize: "1rem",
              color: "#574F4A",
              mt: "4px",
            }}
          >
            {subheading}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          // padding: "0",
          border: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {/* {!hideHeader && (
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {heading}
              </Typography>

              <Typography
                sx={{
                  fontSize: "1rem",
                  color: "#574F4A",
                  mt: "4px",
                }}
              >
                {subheading}
              </Typography>
            </Box>
          )} */}

          {/* MAIN CONTENT */}
          <Box>{children}</Box>

          {errorMessage && (
            <Typography color="error">{errorMessage}</Typography>
          )}
        </Box>
      </DialogContent>

      {!hideFooter && (
        <DialogActions
          sx={{
            // padding: "0",
            // gap: "12px",
             padding: "0 2rem 2rem 0",
          }}
        >
          <Button variant="outlined" onClick={closeModal} disabled={isSubmitting} >
            Cancel
          </Button>

          {!hideaddbutton && (
          <Button onClick={onSave || closeModal} disabled={isSubmitting} variant="contained" sx={{
            backgroundColor : "#6570fc"
          }}>
            {saveButtonText}

            {isSubmitting && (
              <CircularProgress
                size={16}
                sx={{ ml: 1 , color: "#fff"}}
              />
            )}
          </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

export default Modal;
